import moment from "moment"


export const currentTimestamp = moment().format('DD-MM-YYYY');

// export const formattedDate = (momentTimeStamp) => moment(momentTimeStamp).format('DD-MM-YYYY');
